export const calculateDaysDifference = (start: Date, end: Date) => {
  const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate())
  const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate())

  const diffMs = endDate.getTime() - startDate.getTime()
  console.log('diffMs=' + diffMs);
  const diffDays = diffMs / (1000 * 60 * 60 * 24)

  return diffDays
}



/**
 * startDate, endDate: Date nesneleri (sadece yıl/ay/gün kısmı kullanılacak)
 * startTime, endTime: "HH:mm" string formatında (örn: "14:30")
 */
export const calculateDaysDifferenceWithTime = (
  startDate: Date,
  endDate: Date,
  startTime?: string,
  endTime?: string,
  hourDiff?: boolean
) => {
    // String gelirse Date'e çevir
    const start_ = startDate instanceof Date ? startDate : new Date(startDate)
    const end_ = endDate instanceof Date ? endDate : new Date(endDate)
  
    let start = Date.UTC(start_.getFullYear(), start_.getMonth(), start_.getDate())
    let end = Date.UTC(end_.getFullYear(), end_.getMonth(), end_.getDate())

  // Eğer saat bilgisi varsa milisaniye cinsinden ekle
  if (startTime) {
    const [sh, sm] = startTime.split(':').map(Number)
    start += (sh * 60 * 60 + sm * 60) * 1000
  }

  if (endTime) {
    const [eh, em] = endTime.split(':').map(Number)
    end += (eh * 60 * 60 + em * 60) * 1000
  }

  const diffMs = end - start
  const diffDays = diffMs / (1000 * 60 * 60 * 24)

  return hourDiff ? Math.max(1, diffDays) : Math.ceil(diffDays);
}


export const formatDate = (value: unknown): string => {
  if (!value) return '-'
  const d = new Date(String(value))
  if (Number.isNaN(d.getTime())) return '-'
  return d.toLocaleDateString('tr-TR')
}

export const formatExpectedDateTime = (date: Date | null | undefined, time: string | null | undefined): string => {
  if (!date) return ''
  const d = date instanceof Date ? date : new Date(date as any)
  if (isNaN(d.getTime())) return ''
  const datePart = d.toLocaleDateString('tr-TR')
  const timePart = time && typeof time === 'string' ? time : ''
    return timePart ? `${datePart} ${timePart}` : datePart
  }

